/* Adventskalender-Promo: Countdown bis zum Ende des Vorbesteller-Preises
   und leiser Schneefall (wie advent.js, aber sparsamer). */
(function () {
  if (window.__advpInit) return;
  window.__advpInit = true;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 900px)');
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  /* ---------- Countdown ---------- */
  function initCountdowns(root) {
    (root || document).querySelectorAll('[data-advp-cd]:not([data-advp-cd-ready])').forEach(function (el) {
      el.setAttribute('data-advp-cd-ready', '');
      var end = Date.parse(el.dataset.advpCd);
      if (isNaN(end)) return;
      var inline = el.hasAttribute('data-advp-cd-inline');
      var cells = {};
      el.querySelectorAll('[data-u]').forEach(function (b) { cells[b.dataset.u] = b; });
      function set(u, v) {
        var b = cells[u];
        if (!b || b.textContent === v) return;
        b.textContent = v;
        if (!still.matches) { b.classList.remove('is-tick'); void b.offsetWidth; b.classList.add('is-tick'); }
      }
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (left <= 0) { el.classList.add('is-over'); clearInterval(t); return; }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
        if (inline) {
          el.textContent = 'Vorbesteller-Preis: noch ' + (d > 0 ? d + ' T ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        } else {
          set('d', '' + d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
        }
      }
      var t = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Schnee ---------- */
  function initSnow(root) {
    (root || document).querySelectorAll('[data-advp-snow]:not([data-advp-snow-ready])').forEach(function (cv) {
      cv.setAttribute('data-advp-snow-ready', '');
      if (still.matches || !cv.getContext) return;
      var ctx = cv.getContext('2d');
      var layers = [], W = 0, H = 0, running = false, visible = false, ready = false, last = 0;
      var dpr = desktop.matches ? Math.min(window.devicePixelRatio || 1, 2) : 1;
      var minGap = desktop.matches ? 0 : 33;
      var DEPTHS = [{ r: 1, v: 0.28, a: 0.4 }, { r: 1.7, v: 0.48, a: 0.6 }, { r: 2.5, v: 0.75, a: 0.8 }];
      function size() {
        W = cv.clientWidth; H = cv.clientHeight;
        if (!W || !H) return;
        cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.max(9, Math.round(Math.min(desktop.matches ? 70 : 24, W * H / 9000)));
        layers = DEPTHS.map(function (d) {
          var fl = [];
          for (var i = 0; i < Math.ceil(n / 3); i++) fl.push({ x: Math.random() * W, y: Math.random() * H, p: Math.random() * 6.28 });
          return { d: d, fl: fl };
        });
      }
      function step(ts) {
        if (!running) return;
        requestAnimationFrame(step);
        if (ts - last < minGap) return;
        var k = last ? Math.min(3, (ts - last) / 16.7) : 1;
        last = ts;
        ctx.clearRect(0, 0, W, H);
        for (var l = 0; l < layers.length; l++) {
          var L = layers[l], d = L.d;
          ctx.beginPath();
          for (var i = 0; i < L.fl.length; i++) {
            var f = L.fl[i];
            f.y += d.v * k; f.p += 0.01 * k; f.x += Math.sin(f.p) * 0.3 * k;
            if (f.y > H + 4) { f.y = -4; f.x = Math.random() * W; }
            ctx.moveTo(f.x + d.r, f.y);
            ctx.arc(f.x, f.y, d.r, 0, 6.283);
          }
          ctx.fillStyle = 'rgba(255,255,255,' + d.a + ')';
          ctx.fill();
        }
      }
      function toggle() {
        var go = ready && visible && !document.hidden;
        if (go && !running) { running = true; last = 0; requestAnimationFrame(step); }
        if (!go) running = false;
      }
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); };
      idle(function () { size(); ready = true; toggle(); }, { timeout: 2500 });
      window.addEventListener('resize', function () { if (ready) size(); });
      document.addEventListener('visibilitychange', toggle);
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; toggle(); }).observe(cv);
    });
  }

  function init(root) { initCountdowns(root); initSnow(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Warenkorb-Schublade und Filter rendern neu – neue Elemente nachziehen */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
